<template id="Etranger">
	<div>
		<Modele id="Etranger"/>
		<Modele id="WW"/>
		<Modele id="Quitus"/>
		<Modele id="Conformité"/>
	</div>
</template>

<script>
import Modele from '../Modele.vue'
export default {
	components:{Modele},
	name: 'Etranger',
	data () {
		return {}
	}
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Immatriculation/Etranger.vue